// removed by extract-text-webpack-plugin
module.exports = {"calendar-edit-modal":"calendar-edit-modal","calendar-name":"calendar-name","calendar-color":"calendar-color","calendar-note":"calendar-note","calendar-accounts":"calendar-accounts","control-input":"control-input","calendar-auto-forecast":"calendar-auto-forecast","control-switch":"control-switch","control-switch-content":"control-switch-content"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/calendar-edit-modal/calendar-edit-modal.style.sass
// module id = Ntdr
// module chunks = 0